<template>
  <div v-if="program">
    <div v-if="$route.name != 'program'">
      <v-divider class="red divider-custom-height mt-5 ml-3 mr-3"></v-divider>
      <v-card-text class="py-5">
        <h1
          class="text-lg-center text-md-center text-xs-center display-3 font-weight-black primary--text"
        >
          {{ $t("program.program-text") }}
        </h1>
      </v-card-text>
    <!-- <v-divider class="red divider-custom-height mt-2 ml-3 mr-3"></v-divider> -->
    </div>
    <template v-if="program.filters">
      <!-- Search Bar -->
      <v-layout v-if="showSearch" align-center justify-center row wrap>
        <v-flex xs12 sm6 md4 lg3>
          <v-text-field
            v-model="programPayload.filters.search"
            :placeholder="$t('program.filter-item.search-placeholder')"
            append-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append="getActiveProgram"
            @click:append-outer="toggleSearch(false)"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <div class="search-filters py-3 pt-4">
        <!-- Film Sections -->
        <div class="filter-item" v-if="program.filters.film_sections">
          <select
            v-model="programPayload.filters.film_sections"
            class="filter-select dark"
          >
            <option value="">
              {{ $t("program.filter-item.film-section") }}
            </option>
            <option
              v-for="(section, index) in program.filters.film_sections"
              :value="section"
              :key="index"
            >
              {{ section }}
            </option>
          </select>
          <span class="dropdown-icon">&#9660;</span>
        </div>

        <!-- Screenings -->
        <div class="filter-item">
          <select
            v-model="programPayload.filters.screenerDate"
            class="filter-select dark"
          >
            <option value="">
              {{ $t("program.filter-item.screenings") }}
            </option>
            <option
              v-for="(date, index) in program.filters.screenerDates"
              :value="moment.utc(date).local().format('YYYY-MM-DD')"
              :key="index"
            >
              {{ moment.utc(date).local().format("D MMMM") }}
            </option>
          </select>
          <span class="dropdown-icon">&#9660;</span>
        </div>

        <!-- Country -->
        <div class="filter-item" v-if="program.filters.countries">
          <select
            v-model="programPayload.filters.country"
            class="filter-select dark"
          >
            <option value="">{{ $t("program.filter-item.country") }}</option>
            <option
              v-for="(country, index) in program.filters.countries"
              :value="country"
              :key="index"
            >
              {{ country }}
            </option>
          </select>
          <span class="dropdown-icon">&#9660;</span>
        </div>

        <!-- Type -->
        <div class="filter-item" v-if="program.filters.film_types">
          <select
            v-model="programPayload.filters.film_types"
            class="filter-select dark"
          >
            <option value="">{{ $t("program.filter-item.type") }}</option>
            <option
              v-for="(filmType, index) in program.filters.film_types"
              :value="filmType"
              :key="index"
            >
              {{ filmType }}
            </option>
          </select>
          <span class="dropdown-icon">&#9660;</span>
        </div>

        <!-- Year -->
        <div class="filter-item" v-if="program.filters.years">
          <select
            v-model="programPayload.filters.year"
            class="filter-select dark"
          >
            <option value="">{{ $t("program.filter-item.year") }}</option>
            <option
              v-for="(year, index) in program.filters.years"
              :value="year"
              :key="index"
            >
              {{ year }}
            </option>
          </select>
          <span class="dropdown-icon">&#9660;</span>
        </div>
        <!-- OK Button -->
        <div class="filter-item">
          <button @click="$emit('filterActiveProgram')" class="search-button">
            {{ $t('program.filter-item.ok-button') }}
          </button>
        </div>
        <!-- Search Button -->
        <div>
          <v-btn flat fab color="#343a40" @click="toggleSearch(true)">
            <v-icon x-large>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
    <!-- Events -->
    <!-- Events -->
    <template v-if="program.screeners">
        <v-layout align-stretch justify-center row wrap class="mt-5 ml-3 mr-3">
            <v-flex xs12 sm6 md4 lg3 mb-5 v-for="(screener, index) in program.screeners" :key="index">
                <ProgramScreenerWidget :screener="screener" :key="screener.id" />
            </v-flex>
        </v-layout>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ProgramScreenerWidget from "./ScreenerWidget.vue"
export default {
  name: "Program",
  data() {
    return {
      showSearch:false,
    };
  },
  props:{
    program:{
      type: Object,
      default: null
    },
    programPayload: {
      type: Object,
      required: true
    }
  },
  components: {
    ProgramScreenerWidget
  },
  computed: {
    ...mapGetters("app", {
      darkMode: "darkMode",
    }),
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
  },
  methods: {
    goToScreenerPage(screenerId) {
      if (!screenerId) {
        return;
      }
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: screenerId,
        },
      });
    },
    toggleSearch(value){
      this.showSearch = value;
      if(!value){
        this.programPayload.filters.search = null;
      }
    }
  },
};
</script>

<style>
/* Hover styles for dark select button */
.filter-select.dark:hover {
  background-color: #23272b;
}

/* Focus styles for dark select button */
.filter-select.dark:focus {
  box-shadow: 0 0 0 2px #007bff;
  /* Blue border when focused */
}

.search-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.filter-item {
  margin: 10px;
}

.filter-select {
  padding: 10px 30px 10px 20px;
  /* Adjust padding for the dropdown icon */
  border: none;
  border-radius: 25px;
  background-color: #f0f0f0;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  outline: none;
}

.filter-select.dark {
  background-color: #343a40;
  /* Dark background color */
  color: #fff;
  /* White text color */
  border: none;
  /* Remove default border */
  padding-right: 30px;
  /* Add space for dropdown icon */
  cursor: pointer;
  /* Change cursor to pointer */
  position: relative;
  /* Position relative for absolute icon */
}

.filter-select:hover {
  background-color: #e0e0e0;
}

.filter-select:focus {
  box-shadow: 0 0 0 2px #007bff;
}

.search-button {
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  background-color: #343a40;
  /* Dark color */
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  position: relative;
}

.search-button:hover {
  background-color: #23272b;
  /* Darker color on hover */
}

.search-button:active {
  background-color: #1d2124;
  /* Even darker color on click */
}

.dropdown-icon {
  position: relative;
  top: 0;
  right: 22px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #fff;
}

.card-title {
  background-color: #b32e2f !important;
  padding: 10px;
  font-size: 15pt;
}

.v-card__text {
  padding: 0px;
  width: 100%;
}

.card-title a {
  font-family: roboto;
  text-decoration: none;
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}

.description {
  color: #333333;
  font-family: roboto;
}

.card-image {
  position: relative;
  transition: transform 0.6s ease-in-out;
}

.hover-overlay-card {
  overflow: hidden;
  /* Add this line to hide any overflow */
  border: solid white 1px;
}

.card-image:hover {
  transform: scale(1.05);
}

.movie-title {
  background: #b32e2f;
  padding: 0 14px 0px 7px;
  width: fit-content;
}

.movie-name {
  font-family: roboto;
  font-size: 22pt;
}

.director {
  font-family: roboto;
  font-size: 14pt;
}

.movie-description {
  font-weight: bold;
  font-family: roboto;
  font-size: 12pt;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.card-logo {
  width: 55px;
  padding: 5px;
}
.movie-logo-price {
  position: relative;
  left: 18%;
}

/* Play button styles */
.play-button {
  display: none;
  position: relative;
  top: 36%;
  left: 40%;
  padding: 10px;
  transform: translate(-50%, -50%);
  height: 20px;
  width: 20px;
  background-color: none;
  border-radius: 50%;
  text-decoration: none;
}

.play-button::after {
  content: "\e037";
  font-family: "Material Icons";
  top: 36%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
  position: relative;
  padding: 10px;
  border: 2px solid #fff;
  color: white;
  border-radius: 50%;
}

.card-image:hover .play-button {
  display: block;
}

.play-button:hover::after {
  color: #db0369;
  border: 2px solid #db0369;
}

.program-card {
  background-color: white;
}
/* Ribbon styles */
.ribbon {
  position: absolute;
  top: 95px;
  right: -90px;
  background-color: #b32e2f;
  color: white;
  padding: 7px 15px;
  -webkit-transform: rotate(45deg);
  transform: rotate(90deg);
  font-weight: bold;
  font-size: 26px;
  width: 244px;
  text-align: center;
}

.movie-detail {
  font-weight: bold;
  font-family: roboto;
  position: absolute;
}

.movie-container span.movie-detail-onhover {
  opacity: 0;
  transition: all 0.5s;
}

.movie-container:hover span.movie-detail-onhover {
  opacity: 1;
  background-color: #b32e2f;
  position: absolute;
  padding: 12px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: bold;
}

.movie-price {
  font-weight: bold;
  font-family: roboto;
  position: relative;
  top: -12px;
}
</style>
